import { render, staticRenderFns } from "./lista-buscador-seleccion-editar-estado.vue?vue&type=template&id=4cb02616&scoped=true&"
import script from "./lista-buscador-seleccion-editar-estado.vue?vue&type=script&lang=ts&"
export * from "./lista-buscador-seleccion-editar-estado.vue?vue&type=script&lang=ts&"
import style0 from "./lista-buscador-seleccion-editar-estado.vue?vue&type=style&index=0&id=4cb02616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb02616",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VRow,VSpacer})
